// libs
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Props and Context
const propTypes = {
  abbreviation: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  filled: PropTypes.bool,
};

const defaultProps = {
  filled: false,
};

const contextTypes = {
  t: PropTypes.func,
};

function CardTag(props) {
  const { abbreviation, filled, name } = props;
  return (
    <span
      className={classNames('tag', {
        'tag--fill-light': filled,
      })}
      title={name}
    >
      {abbreviation}
    </span>
  );
}

CardTag.contextTypes = contextTypes;
CardTag.defaultProps = defaultProps;
CardTag.propTypes = propTypes;

export default CardTag;



// WEBPACK FOOTER //
// ./src/app/components/cards/card/parts/cardTags/CardTag.js